import {
  BadgeCheck,
  Code2,
  GlobeLock,
  LayoutDashboard,
  SearchCheck,
  TrendingUp,
} from "lucide-react";
import chooseVisual from "../../assets/images/working-bg.png";
import ResponsiveImage from "../common/ResponsiveImage";

const chooseCards = [
  {
    title: "Cam Kết Chuẩn SEO",
    description:
      "Website được xây dựng trên cấu trúc thân thiện công cụ tìm kiếm, hỗ trợ cải thiện khả năng index và tiếp cận khách hàng tiềm năng tốt hơn.",
    icon: SearchCheck,
  },
  {
    title: "Mã Nguồn Rõ Ràng",
    description:
      "Cấu trúc code sạch, dễ bảo trì và đủ mở để doanh nghiệp có thể nâng cấp tính năng, tích hợp thêm hệ thống trong các giai đoạn sau.",
    icon: Code2,
  },
  {
    title: "Công Nghệ Hiện Đại",
    description:
      "TrioCore cập nhật các tiêu chuẩn giao diện, hiệu năng và trải nghiệm người dùng để website luôn phù hợp với xu hướng vận hành hiện nay.",
    icon: LayoutDashboard,
  },
  {
    title: "An Toàn Bảo Mật",
    description:
      "Chúng tôi chú trọng nền tảng bảo mật, kiểm soát rủi ro và tối ưu khả năng vận hành ổn định lâu dài cho website doanh nghiệp.",
    icon: GlobeLock,
  },
  {
    title: "Tối Ưu Tốc Độ",
    description:
      "Website được tối ưu hiệu năng tải trang, hiển thị mượt trên nhiều thiết bị và hỗ trợ tốt hơn cho trải nghiệm người dùng lẫn SEO.",
    icon: TrendingUp,
  },
  {
    title: "Hỗ Trợ Dài Hạn",
    description:
      "Không dừng ở bàn giao, TrioCore tiếp tục hỗ trợ tinh chỉnh, bảo trì và tư vấn hướng phát triển phù hợp với từng giai đoạn tăng trưởng.",
    icon: BadgeCheck,
  },
];

const SectionWebsiteChoose: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#fffdfd_0%,#fff7f7_100%)] py-16 sm:py-18 lg:py-20">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[-120px] top-8 h-72 w-72 rounded-full bg-red-100/70 blur-3xl" />
        <div className="absolute bottom-0 right-[-100px] h-80 w-80 rounded-full bg-rose-100/70 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6">
        <div className="grid items-start gap-8 lg:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)] lg:gap-12">
          <div className="text-left">
            <span className="inline-flex rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700">
              Lý do lựa chọn
            </span>

            <h2 className="mt-5 max-w-[620px] text-[26px] font-semibold leading-[1.18] text-[#d92d20] sm:text-[32px] lg:text-[40px]">
              Tại Sao Nên Chọn Dịch Vụ Thiết Kế Website Tại TrioCore Solutions
            </h2>

            <p className="mt-5 max-w-[560px] text-[15px] leading-8 text-slate-600 sm:text-[16px]">
              TrioCore Solutions tập trung vào giá trị vận hành thực tế, hiệu quả tăng trưởng dài hạn và
              khả năng đồng hành rõ ràng để website không chỉ đẹp mà còn đủ chắc cho hoạt động kinh doanh.
            </p>

            <div className="mt-8">
              <ResponsiveImage
                src={chooseVisual}
                alt="TrioCore Solutions website service"
                className="mx-auto h-auto w-full max-w-[460px] object-contain lg:mx-0"
              />
            </div>
          </div>

          <div className="grid gap-5 md:grid-cols-2">
            {chooseCards.map(({ title, description, icon: Icon }) => (
              <article
                key={title}
                className="rounded-[22px] border border-red-100 bg-[linear-gradient(180deg,#ffffff_0%,#fff8f8_100%)] p-5 text-left shadow-[0_16px_34px_rgba(127,29,29,0.06)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(127,29,29,0.08)]"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[linear-gradient(180deg,#ff5a47_0%,#dc2626_100%)] text-white shadow-[0_8px_20px_rgba(220,38,38,0.18)]">
                  <Icon size={20} />
                </div>

                <h3 className="mt-5 text-[18px] font-semibold leading-6 text-[#2f1a1a]">{title}</h3>
                <p className="mt-3 text-[14px] leading-7 text-slate-600">{description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionWebsiteChoose;
